import { Fragment, useEffect, useState } from "react";
import baseUrl from "../../url/baseUrl";
import addDotsToPrice from "../price-format";
import { Link } from "react-router-dom";
import ClockLoader from "react-spinners/ClockLoader";

// component lấy 4 sản phẩm bán chạy nhất
const BestSellProd = () => {
  const [products, setProducts] = useState([]);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    setLoading(true);
    async function fetchProductData() {
      try {
        const response = await fetch(baseUrl + "/products");

        if (response.status === 404) {
          throw new Error("Can't find best seller product!");
        }

        if (response.status !== 200) {
          throw new Error("Something went wrong.");
        }

        setError(null);
        const productItem = await response.json();

        setProducts(productItem);
        setLoading(false);
      } catch (err) {
        setLoading(false);
        setError(err.message);
      }
    }

    fetchProductData();
  }, []);

  return (
    <Fragment>
      {error && <p style={{ color: "red", textAlign: "center" }}>{error}</p>}
      {/* show spinner while loading */}
      {loading && (
        <div className="d-flex justify-content-center align-items-center">
          <ClockLoader color="#36d7b7" size={50} />
        </div>
      )}

      {products.length !== 0 && (
        <section className="border-bottom mb-4 mt-5">
          <p className="text-uppercase text-center text-success mb-4">
            Sản phẩm được yêu thích
          </p>
          <div className="container">
            <div className="row g-4">
              {products.map((prod, i) => (
                <div
                  className="col-12 col-sm-6 col-md-4 col-lg-3 text-center"
                  key={i}
                >
                  <Link
                    className="text-decoration-none"
                    to={`/products/${prod._id}`}
                  >
                    <img
                      className="img-fluid"
                      style={{ maxWidth: "80%", cursor: "pointer" }}
                      src={hoveredIndex === i ? prod.img4 : prod.img1}
                      onMouseEnter={() => setHoveredIndex(i)}
                      onMouseLeave={() => setHoveredIndex(null)}
                      alt={prod.name}
                    />
                    <p className="text-primary mb-0">{prod.name}</p>
                    <p className="text-danger fst-italic">
                      {addDotsToPrice(prod.price)}
                    </p>
                  </Link>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}
    </Fragment>
  );
};

export default BestSellProd;
